import { NavigationBar } from "../NavigationBar/NavigationBar";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import './PageLayout.css';

export const PageLayout = ({children}) => {
    return (
        <div className='layout-container bg-light'>
            <NavigationBar />
            <Main children={children} />
            {/* <Footer /> */}
        </div>
    );
}